import { ActionIcon, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import React from "react";

export default function InfoIconWithTooltip({ tooltipText, position, color, size, ...rest }) {
  return (
    <Tooltip
      withArrow
      multiline={true}
      w={"300px"}
      label={tooltipText} // Use tooltipText here
      position={position || "right"}
    >
      <ActionIcon {...rest} radius={"lg"} variant="subtle" color={color || "gray.5"}>
        <IconInfoCircle size={size || "1.5rem"} />
      </ActionIcon>
    </Tooltip>
  );
}
